/*
 *  ~~~~~ Copyright by inndevs GmbH / DDC Engineering GmbH ~~~~~
 *
 *               Your favorite programmers ;-)
 *
 * E-Mail:   hannes@inndevs.com
 *           dominic@ddc-engineering.at
 * Web:      https://inndevs.com
 *           https://ddc-engineering.at
 * Date:     2021-05-16
 *
 *   ________________________________________
 * [[ MESS WITH THE BEST - DiE LIKE THE REST ]]
 *   ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
 */

import React from "react";
import ReactDOM from "react-dom";
import App, {loadConfiguration} from "./App";
import Amplify from "aws-amplify";

import {BrowserRouter as Router} from "react-router-dom";
import {putGermanVocabulary} from "./js/translate";

loadConfiguration().then(config => {
    Amplify.configure(config.default['awsConfig']);

    Amplify.configure({
        API: {
            endpoints: [
                {
                    name: "key-direct-api",
                    endpoint: config.default['endpoint']
                    //endpoint: "http://localhost:3001"
                    //endpoint: "https://sly1fh02h0.execute-api.eu-central-1.amazonaws.com/v1"
                },{
                    name: "local-test",
                    endpoint: "http://localhost:3001"
                }
            ]
        }
    });
});

putGermanVocabulary();

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <App/>
        </Router>
    </React.StrictMode>,
    document.getElementById("root")
);
